import s from "@common/Chat/MainChatPage/MainChatsView.module.css";
import ChatView from "@common/Chat/components/ChatView/ChatView";
import Popup from "@common/Chat/components/Popup/Popup";
import {useEffect, useRef, useState} from "react";
import {chatApi} from "@/api";
import {useAddAlert} from "@/hooks/useAddAlert";
import classNames from "classnames";
import { convertURLs } from "../helpers/convertURLs";

const ChatViewList = ({
    chats,
    setPage,
    setIsNeedUpdate,
    unReadChats,
    isTechSupport,
    supportStatusOptions,
    supportManagerOptions,
    onChangeSupportStatus,
    onAssignSupportTicketManager,
    onLoadMore,
    onReadStateChange,
}) => {
    const addAlert = useAddAlert();
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);
    const [type, setType] = useState(null);
    const [chatId, setChatId] = useState(null);
    const [action,setAction] = useState(null)
    const [header, setHeader] = useState(null);
    const [actionCallback, setActionCallback] = useState(null)
    useEffect(() => {
        if (action) {
            if (type === 'remove') {
                deleteChat(chatId)
            } else {
                // fix-chat — toggle: тем же запросом и закрепляем, и открепляем конкретный чат.
                // chat/unfix-chat открепляет произвольный чат пользователя: он ищет ChatFix
                // только по user_id, без chat_id.
                fixChat(chatId)
            }
            setAction(false)
            setIsVisiblePopup(false)
            setType('')
        }

    }, [type, action]);

    const deleteChat = (id) => {
        chatApi.removeChat(id).then((res) =>  {
            if (res?.status === 200) {
                setIsNeedUpdate()
            } else {
                addAlert({text: res?.response?.data?.error})

            }
        })
    }

    const fixChat = (id) => {
        chatApi.fixChat(id).then((res) =>  {

            if (res?.status === 200) {
                setIsNeedUpdate()
            }
        })
    }

    const handleScroll = (event) => {
        if (!onLoadMore) return

        const { scrollTop, scrollHeight, clientHeight } = event.currentTarget
        const isNearBottom = scrollHeight - scrollTop - clientHeight < 80

        if (isNearBottom) {
            onLoadMore()
        }
    }

    return (
        <>
            <div
                className={classNames('new-design-scroll', s.chats, s.order)}
                onScroll={handleScroll}
            >
                {chats && chats.map(chat => (
                    <ChatView
                        setAction={setAction}
                        chat={{
                            ...chat,
                            lastMessage: {
                                ...chat?.lastMessage,
                                message: convertURLs(chat?.lastMessage?.message)
                            }
                        }}
                        key={chat.id}
                        setHeader={setHeader}
                        setPage={setPage}
                        unReadChats={unReadChats}
                        isVisiblePopup={isVisiblePopup}
                        setChatId={setChatId}
                        setActionCallback={setActionCallback}
                        setType={setType}
                        action={action}
                        isTechSupport={isTechSupport}
                        supportStatusOptions={supportStatusOptions}
                        supportManagerOptions={supportManagerOptions}
                        onChangeSupportStatus={onChangeSupportStatus}
                        onAssignSupportTicketManager={onAssignSupportTicketManager}
                        onReadStateChange={onReadStateChange}
                        setIsVisiblePopup={setIsVisiblePopup} closeCallback={() => setIsVisiblePopup(false)}
                    />
                ))}
            </div>
            {isVisiblePopup && <Popup
                isVisiblePopup={isVisiblePopup}
                closeCallback={() => setIsVisiblePopup(false)}
                header={header}
                action={action}
                setAction={setAction}
                setActionCallback={setActionCallback}
            />}
        </>

    )
}

export default ChatViewList;
